import { Wapp } from '@weblite/ts-action/wapp'
import { RootState } from '$setup/redux'
import { createUseEntity } from '$func/create-use-entity.react-hook'
import { getWapp } from '$logic/wapps/service'

const getWappView = (wappId: string) => (state: RootState): Wapp =>
  state.main.wapps[wappId]

export const useWapp = createUseEntity(getWappView, getWapp)
